import {AnyAction} from 'redux'
import {crudReducer, CrudState, initialCrudState} from 'lib/crud'

export const name = 'SCHOOL_TYPE'

export type SchoolTypeState = {
    crud: CrudState,
}

const initialState = {
    crud: initialCrudState,
}

export function schoolTypeReducer(state: SchoolTypeState = initialState, action: AnyAction): SchoolTypeState {
    switch (action.type) {
        default:
            return {
                ...state,
                crud: crudReducer(name, state.crud, action)
            }
    }
}
